<template>
  <div class="back">
    <crumb prevLevel="预警总览" :current="enterpriseName" />
    <el-form label-width="80px" class="search">
      <el-row>
        <el-col :span="6">
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="queryParams.time"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="1">
          <el-button type="primary" @click="init">查询</el-button>
        </el-col>
      </el-row>
    </el-form>
    <div class="title">预警趋势图</div>
    <echarts :echartsOption="echartsOption1" echartsHeight="377px" />
    <div class="statistic">
      <div class="body">
        <div class="num-statics">
          <div class="title">
            <p class="text">预警分类占比</p>
            <p class="sub-text">按照预警类型统计</p>
          </div>
          <Echarts echartsHeight="475px" :echartsOption="echartsOption2" />
        </div>
        <div class="scale-statics">
          <div class="title">
            <p class="text">预警处置状态</p>
            <p class="sub-text">按照预警状态统计</p>
          </div>
          <Echarts :echartsOption="echartsOption3" echartsHeight="475px" />
        </div>
        <div class="border"></div>
      </div>
    </div>
    <warning-list
      :warningList="warningList"
      :total="warningTotalCount"
      @current-change="loadWarnListByPage"
    />
  </div>
</template>

<script>
import Crumb from 'components/crumb/crumb';
import Echarts from 'components/echarts/echarts';
import WarningList from 'components/warning/list';

export default {
  data() {
    return {
      enterpriseName: '',
      queryParams: {
        time: ''
      },
      echartsOption1: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: [
            '证照异常',
            '原辅料异常',
            '生产存储异常&运输异常',
            '进销存异常'
          ],
          bottom: '30px',
          textStyle: {
            color: '#666666'
          }
        },
        grid: {
          top: '20px',
          left: '3%',
          right: '4%',
          bottom: '70px',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLine: {
              show: true,
              lineStyle: {
                color: '#CEDBEF'
              }
            },
            axisLabel: {
              color: '#999999'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#CEDBEF'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#CEDBEF'
              }
            },
            axisLabel: {
              color: '#999999'
            },
            minInterval: 1
          }
        ],
        series: [
          {
            name: '证照异常',
            type: 'line',
            stack: '总量',
            lineStyle: {
              color: '#FFB439'
            },
            itemStyle: {
              color: '#FFB439'
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#FFB439'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              }
            },
            data: []
          },
          {
            name: '原辅料异常',
            type: 'line',
            stack: '总量',
            lineStyle: {
              color: '#2BBF99'
            },
            itemStyle: {
              color: '#2BBF99'
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#2BBF99'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              }
            },
            data: []
          },
          {
            name: '生产存储异常&运输异常',
            type: 'line',
            stack: '总量',
            itemStyle: {
              color: '#386CE2'
            },
            lineStyle: {
              color: '#386CE2'
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#386CE2'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              }
            },
            data: []
          },
          {
            name: '进销存异常',
            type: 'line',
            stack: '总量',
            lineStyle: {
              color: '#CEDBEF'
            },
            itemStyle: {
              color: '#CEDBEF'
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#CEDBEF'
                  },
                  {
                    offset: 1,
                    color: '#fff'
                  }
                ])
              }
            },
            data: []
          }
        ]
      },
      echartsOption2: {
        gird: {
          containLabel: true
        },
        legend: [
          {
            bottom: '30px',
            x: 'center',
            itemGap: 21,
            data: [
              '证照异常',
              '原辅料异常',
              '生产存储异常&仓储运输异常',
              '进销存异常'
            ],
            itemWidth: 12,
            itemHeight: 12,
            icon: 'circle'
          }
        ],
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        color: ['#0B428A', '#975FE4', '#386CE2', '#FFB439'],
        series: [
          {
            name: '预警分类占比',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['40%', '55%'],
            data: [],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '预警分类占比',
            type: 'pie',
            animation: false,
            center: ['50%', '40%'],
            radius: ['60%', '65%'],
            data: [],
            label: {
              normal: {
                color: '#386CE2',
                formatter: '{c|数量：{c}}\n{d|{d}%}',
                rich: {
                  c: {
                    color: '#386CE2'
                  },
                  d: {
                    color: '#999999',
                    lineHeight: '20'
                  }
                }
              }
            },
            labelLine: {
              show: true,
              lineStyle: {
                color: '#386CE2'
              }
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '预警分类占比',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['0', '30%'],
            data: [{ value: 100 }],
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(206, 219, 239, 1)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(206, 219, 239, 0)' // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            tooltip: {
              show: false
            },
            label: {
              normal: {
                formatter: '预警分类占比',
                position: 'center',
                textStyle: {
                  fontSize: 16,
                  color: '#386CE2'
                }
              }
            }
          }
        ]
      },
      echartsOption3: {
        gird: {
          containLabel: true
        },
        legend: [
          {
            bottom: '30px',
            x: 'center',
            itemGap: 21,
            data: ['处置中', '企业已反馈', '已处置'],
            itemWidth: 12,
            itemHeight: 12,
            icon: 'circle'
          }
        ],
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        color: ['#0B428A', '#975FE4', '#386CE2'],
        series: [
          {
            name: '预警处置状态',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['40%', '55%'],
            data: [],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '预警处置状态',
            type: 'pie',
            animation: false,
            center: ['50%', '40%'],
            radius: ['60%', '65%'],
            data: [],
            label: {
              normal: {
                color: '#386CE2',
                formatter: '{c|数量：{c}}\n{d|{d}%}',
                rich: {
                  c: {
                    color: '#386CE2'
                  },
                  d: {
                    color: '#999999',
                    lineHeight: '20'
                  }
                }
              }
            },
            labelLine: {
              show: true,
              lineStyle: {
                color: '#386CE2'
              }
            },
            itemStyle: {
              normal: {
                borderColor: '#ffffff',
                borderWidth: 5
              }
            }
          },
          {
            name: '预警处置状态',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['0', '30%'],
            data: [{ value: 100 }],
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(206, 219, 239, 1)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(206, 219, 239, 0)' // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              }
            },
            tooltip: {
              show: false
            },
            label: {
              normal: {
                formatter: '预警处置状态',
                position: 'center',
                textStyle: {
                  fontSize: 16,
                  color: '#386CE2'
                }
              }
            }
          }
        ]
      },
      warningList: [],
      warningTotalCount: 0
    };
  },
  mounted() {
    this.enterpriseName = this.$route.params.enterpriseName;
    this.init();
  },
  methods: {
    init() {
      const time = this.queryParams.time;
      this.loadTrendData(time);
      this.loadClassifyData(time);
      this.loadDealStatus(time);
      this.loadWarnList(time);
    },
    loadTrendData(time) {
      this.$request({
        url: 'rest/riskWarnStatistics/riskWarnTrendStatistics',
        data: {
          json: JSON.stringify({
            params: {
              createEndTime: time ? time[1] : '',
              createStartTime: time ? time[0] : '',
              enterpriseName: this.enterpriseName
            }
          })
        }
      }).then(res => {
        const xData = Object.keys(res);
        const yData = Object.values(res);
        const riskEntData = [];
        const riskYclData = [];
        const riskScData = [];
        const riskJxcData = [];
        yData.forEach(item => {
          riskEntData.push(item.riskEntNum);
          riskYclData.push(item.riskJxcNum);
          riskScData.push(item.riskScNum);
          riskJxcData.push(item.riskYclNum);
        });
        this.echartsOption1.xAxis[0].data = xData;
        this.echartsOption1.series[0].data = riskEntData;
        this.echartsOption1.series[1].data = riskYclData;
        this.echartsOption1.series[2].data = riskScData;
        this.echartsOption1.series[3].data = riskJxcData;
      });
    },
    loadClassifyData(time) {
      this.$request({
        url: 'rest/riskWarnStatistics/riskWarnClassifyProportionStatistics',
        data: {
          json: JSON.stringify({
            params: {
              createEndTime: time ? time[1] : '',
              createStartTime: time ? time[0] : '',
              enterpriseName: this.enterpriseName
            }
          })
        }
      }).then(res => {
        const data = [
          {
            name: '证照异常',
            value: res.riskEntNum
          },
          {
            name: '原辅料异常',
            value: res.riskYclNum
          },
          {
            name: '生产存储异常&仓储运输异常',
            value: res.riskScNum
          },
          {
            name: '进销存异常',
            value: res.riskJxcNum
          }
        ].filter(item => item.value);
        if (data.length === 1) {
          this.echartsOption2.series[0].itemStyle.normal.borderWidth = 0;
          this.echartsOption2.series[1].itemStyle.normal.borderWidth = 0;
        }
        this.echartsOption2.series[0].data = data;
        this.echartsOption2.series[1].data = data;
      });
    },
    loadDealStatus(time) {
      this.$request({
        url: 'rest/riskWarnStatistics/riskWarnDealStatusStatistics',
        data: {
          json: JSON.stringify({
            params: {
              createEndTime: time ? time[1] : '',
              createStartTime: time ? time[0] : '',
              enterpriseName: this.enterpriseName
            }
          })
        }
      }).then(res => {
        const data = [
          {
            name: '处置中',
            value: res[0] ? res[0].czzNum : 0
          },
          {
            name: '企业已反馈',
            value: res[0] ? res[0].zfkNum : 0
          },
          {
            name: '已处置',
            value: res[0] ? res[0].zczNum : 0
          }
        ].filter(item => item.value);
        if (!data.length || data.length === 1) {
          this.echartsOption3.series[0].itemStyle.normal.borderWidth = 0;
          this.echartsOption3.series[1].itemStyle.normal.borderWidth = 0;
        }
        this.echartsOption3.series[0].data = data;
        this.echartsOption3.series[1].data = data;
      });
    },
    loadWarnListByPage(currentPage) {
      const time = this.queryParams.time;
      this.loadWarnList(time, currentPage);
    },
    loadWarnList(time, currentPage) {
      this.$request({
        url: 'rest/riskWarnStatistics/riskWarnInfoDetailList',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: currentPage || 1,
              pageSize: 7
            },
            params: {
              enterpriseName: this.enterpriseName,
              createEndTime: time ? time[1] : '',
              createStartTime: time ? time[0] : ''
            }
          })
        }
      }).then(res => {
        this.warningList = res.list;
        this.warningTotalCount = res.total;
      });
    }
  },
  components: {
    Crumb,
    Echarts,
    WarningList
  }
};
</script>

<style lang="stylus" scoped>
.back
  padding 0 20px 15px 20px
  border-radius 4px
  background #fff
  color #000
  .search
    margin 30px 0
  >.title
    line-height 30px
    font-size 14px
  .statistic
    background #fff
    margin-top 20px
    overflow hidden
    color #000
    border-top 1px solid rgba(206,219,239,0.5)
    border-bottom 1px solid rgba(206,219,239, .5)
    margin-bottom 20px
    .body
      position relative
      overflow hidden
      .num-statics
        position relative
        width 50%
        float left
        .echarts-border
          position absolute
          width 1px
          background rgba(206,219,239,.5)
          left 504px
          top 190px
          height 320px
      .scale-statics
        width 50%
        float left
        .title
          padding-left 30px
      .border
        width 1px
        position absolute
        top 0
        left 50%
        bottom 0
        background rgba(206,219,239,.5)
      .title
        border-bottom 1px solid #CEDBEF
        padding 5px 0
        .text
          font-size 14px
          margin-bottom 5px
        .sub-text
          font-size 12px
          color #666666
      .num-list
        display flex
        justify-content center
        .num-item
          margin 0 20px
          text-align center
          padding-top 30px
          .num
            color #386CE2
            font-size 28px
          .text
            font-size 12px
</style>
